import { lang } from "../../i18nLang";

export class DiscountLinkedException extends Error {
  protected _code: string;

  constructor() {
    super(lang("discounts.error.onDeleteWithMeasurement"));

    this.name = "DiscountLinkedException";
    this._code = "discountLinked";
  }
}

export class AdvanceLinkedException extends Error {
  protected _code: string;

  constructor() {
    super(lang("advances.error.onDeleteWithMeasurement"));

    this.name = "AdvanceLinkedException";
    this._code = "advanceLinked";
  }
}
